export const clamp = (value: number, minimum: number, maximum: number): number =>
  Math.min(Math.max(value, minimum), maximum);

export const saturate = (value: number): number => clamp(value, 0, 1);

export const approach = (value: number, target: number, maximumDelta: number): number => {
  if (value < target) {
    return Math.min(value + maximumDelta, target);
  }

  return Math.max(value - maximumDelta, target);
};

export const lerp = (start: number, end: number, amount: number): number =>
  start + (end - start) * amount;

export const wrap01 = (value: number): number => {
  const wrapped = value % 1;
  return wrapped < 0 ? wrapped + 1 : wrapped;
};

export const signedWrappedDelta = (from: number, to: number): number => {
  const rawDelta = to - from;

  if (rawDelta > 0.5) {
    return rawDelta - 1;
  }

  if (rawDelta < -0.5) {
    return rawDelta + 1;
  }

  return rawDelta;
};

export const finiteOr = (value: number, fallback: number): number =>
  Number.isFinite(value) ? value : fallback;
